import React, { ComponentProps, useMemo } from 'react'

import { HomeLayout } from '@factorialco/f0-react'
import { DaytimePage } from '@factorialco/f0-react/dist/experimental'

import ErrorBoundary from 'modules/core/components/ErrorBoundary'
import {
  ExtractCommonWidgetArgs,
  NoQueryWidgetParams,
  Widget,
  WidgetParams,
  useWidgetsContext,
} from 'modules/core/lib/widgets'

import { getMomentOfDay } from 'modules/dashboard/lib/getMomentOfDay'

import './style.css'

export function WidgetDashboard<
  TWidgets extends ReadonlyArray<WidgetParams | NoQueryWidgetParams>,
>({
  widgets,
  args,
  header,
  children,
}: Readonly<{
  widgets: TWidgets
  args: ExtractCommonWidgetArgs<TWidgets>
  header: ComponentProps<typeof DaytimePage>['header']
  children?: React.ReactNode
}>) {
  const { widgetStates } = useWidgetsContext()

  const momentOfDay = getMomentOfDay()

  const widgetsToPass = useMemo(
    () =>
      widgets.map((widget) => {
        const state = widgetStates[widget.id]

        if (state === 'empty_and_not_shown') return null

        return (
          <ErrorBoundary key={widget.id} customCrashComponent={<></>}>
            <Widget widget={widget} args={args} />
          </ErrorBoundary>
        )
      }),
    [widgets, args, widgetStates]
  )

  return (
    <DaytimePage header={header} period={momentOfDay}>
      <HomeLayout widgets={widgetsToPass}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </HomeLayout>
    </DaytimePage>
  )
}
